import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { mapSizeType, mapColorType } from "./constants.js";
import { StyledIconButton } from "./styles.js";
const IconButton = forwardRef(
  ({ size = "xl", color = "primary", children, ...props }, ref) => /* @__PURE__ */ jsx(
    StyledIconButton,
    {
      ref,
      size: mapSizeType[size],
      color: mapColorType[color],
      ...props,
      children
    }
  )
);
export {
  IconButton
};
//# sourceMappingURL=IconButton.js.map
